// CSV export helpers shared by the dashboard, the line item explorer and the invoice table.

const escapeCell = (value) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return `"${value.replace(/"/g, '""')}"`;
  return String(value);
};

// Builds CSV text from an array of objects. Columns are the union of all keys,
// in first-seen order, so rows with extra fields are not silently truncated.
export const toCsv = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) return '';
  const headers = [];
  const seen = new Set();
  rows.forEach((row) => {
    Object.keys(row).forEach((key) => {
      if (!seen.has(key)) {
        seen.add(key);
        headers.push(key);
      }
    });
  });
  const lines = [headers.map(escapeCell).join(',')];
  rows.forEach((row) => {
    lines.push(headers.map((field) => escapeCell(row[field])).join(','));
  });
  return lines.join('\n');
};

export const toFileSlug = (value) =>
  String(value || '')
    .trim()
    .replace(/[^a-z0-9]+/gi, '_')
    .replace(/^_+|_+$/g, '')
    .toLowerCase() || 'export';

export const todayStamp = () => new Date().toISOString().slice(0, 10);

export const downloadTextFile = (filename, content, mimeType = 'text/csv;charset=utf-8') => {
  downloadBlob(filename, new Blob([content], { type: mimeType }));
};

export const downloadBlob = (filename, blob) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  if (typeof window.URL.revokeObjectURL === 'function') {
    window.URL.revokeObjectURL(url);
  }
};
